import { render, staticRenderFns } from "./lightbox.vue?vue&type=template&id=09580eca&scoped=true&"
import script from "./lightbox.vue?vue&type=script&lang=js&"
export * from "./lightbox.vue?vue&type=script&lang=js&"
import style0 from "./lightbox.vue?vue&type=style&index=0&id=09580eca&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09580eca",
  null
  
)

export default component.exports